import { Content } from '../../types';

export const hoiAnContent: Content = {
  title: 'הוי אן: הפנינה העתיקה של וייטנאם',
  imageUrl: '/images/vietnam/hoi-an/hoi-an-wide.jpeg',
  introduction: `הוי אן הינה אחת הערים היפות והמיוחדות ביותר בוייטנאם, עיר עתיקה ומלאת קסם השוכנת במרכז המדינה, על גדות נהר Thu Bon. העיר ממוקמת כ-600 ק"מ מהאנוי שבצפון ומהו צ'י מין סיטי שבדרום ונחשבת ליעד חובה לכל מטייל המבקר בוייטנאם. בשנת 1999 הוכרזה הוי אן כאתר מורשת עולמית של אונסק"ו, בזכות השימור יוצא הדופן של המבנים ההיסטוריים, הרחובות הציוריים והאווירה הייחודית ששוררת בה.`,
  sections: [
    {
      title: 'עיר מסחר היסטורית עם השפעות בינלאומיות',
      content: `הוי אן הייתה בעבר עיר נמל מרכזית ומוקד מסחרי חשוב שהשפיע על התפתחות האזור כולו. סוחרים מסין, יפן ואירופה פקדו את המקום והשפיעו על הארכיטקטורה המקומית, מה שניכר במבנים המעוטרים בגגות מקושתים, חצרות פנימיות וגשרים מקורים. אחד הסמלים הבולטים ביותר של העיר הוא הגשר היפני העתיק, שנבנה במאה ה-16 על ידי סוחרים יפנים ונשמר עד היום.`,
      type: 'text',
    },
    {
      title: 'אווירה קסומה ואמנות מקומית',
      content: `כיום, הוי אן הינה עיר תיירותית תוססת, המושכת אליה מבקרים מכל העולם, בזכות המבנים העתיקים, הרחובות הצרים, הפנסים הצבעוניים והאווירה הרומנטית ששוררת בה. העיר ידועה גם בסצנה האמנותית שלה, הכוללת גלריות, חנויות של עבודות יד וסדנאות יצירה. ניתן להשתתף בסדנאות מגוונות כמו כדרות, צורפות, יצירת פנסי נייר בעבודת יד ואף סדנאות בישול מקומי, בהן ניתן ללמוד להכין מנות וייטנאמיות מסורתיות.`,
      type: 'text',
    },
    {
      title: 'עיר החייטים של וייטנאם',
      content: `הוי אן מכונה גם "עיר החייטים" של וייטנאם, זאת בזכות כמות אדירה של חנויות חייטים המציעים בגדים בהתאמה אישית, מנעליים ועד שמלות מחוייטות. התהליך מהיר להפליא - ניתן להזמין בגד מותאם אישית ולקבלו תוך יום-יומיים בלבד.`,
      type: 'text',
    },
    {
      title: 'חוויות מומלצות בהוי אן',
      content: [
        'רכיבה על אופניים - הדרך האידיאלית לטייל בסמטאות הציוריות של העיר העתיקה, הינה באמצעות אופניים, אותן ניתן לשכור כמעט בכל פינת רחוב.',
        'שייט רומנטי בנהר - עם רדת ערב, ניתן לשוט בסירה על נהר Thu Bon ולשחרר פנסים צפים, חוויה קסומה במיוחד.',
        'שוק הלילה של הוי אן - חוויה ססגונית עם דוכנים למזכרות, אוכל רחוב מקומי ושלל פנסים זוהרים.',
        'ביקור במקדשים העתיקים - העיר משופעת במקדשים סיניים ויפניים המשלבים ארכיטקטורה מסורתית מרשימה.',
      ],
      type: 'list',
    },
    {
      title: 'טיולי יום מהוי אן',
      content: [
        'פארק בא נא הילס וגשר הידיים המפורסם - אחד מאתרי התיירות הפופולריים ביותר בוייטנאם, בו גשר מרשים הנתמך בידי ענק.',
        'הרי השיש - רכס הרים מרהיב עם מערות חבויות, פסלים בודהיסטיים ונוף עוצר נשימה.',
        'החופים של דה נאנג - חופי חול לבן ומים צלולים הנמצאים במרחק נסיעה קצר מהוי אן.',
        "האי צ'אם - יעד נהדר לצלילה ושנורקלינג, עם מי טורקיז ושוניות אלמוגים מרהיבות.",
        'הואה - עיר המלכים - בירתה ההיסטורית של וייטנאם הקיסרית, בה ניתן לבקר בארמון המלכותי ובקברי הקיסרים.',
      ],
      type: 'list',
    },
    {
      title: 'בשורה התחתונה',
      content: `בשורה התחתונה, הוי אן הינה שילוב מושלם בין היסטוריה, תרבות, אומנות ואווירה רומנטית. בין אם אתם מחפשים רחובות עתיקים לצילום, אוכל מקומי משובח או סתם לשבת בבית קפה ולספוג את האווירה הייחודית - הוי אן הינה יעד שלא תרצו לפספס בטיולכם לוייטנאם.`,
      type: 'text',
    },
  ],
};
